import Box from '@mui/material/Box';

import { Job } from '~hooks/useJob/models';
import { Load } from '~hooks/useLoad/models';
import { Order } from '~hooks/useOrders/models';
import { Ticket } from '~hooks/useTickets/models';

import { columns, gridTemplateColumns } from './loads-tab-loads-table-columns';
import TableHeader from './TableHeader';
import TableRow from './TableRow';

interface LoadsTabLoadsTableProps {
  jobs: Job[];
  loads: Load[];
  onTableRowClick: (loadNumber: number, load: Load, ticket?: Ticket) => void;
  order: Order;
  tickets: Ticket[];
}

export default function LoadsTabLoadsTable({
  jobs,
  loads,
  onTableRowClick,
  order,
  tickets,
}: LoadsTabLoadsTableProps) {
  return (
    <>
      <Box
        sx={(theme) => ({
          borderInline: `solid 1px ${theme.palette.divider}`,
          borderTop: `solid 1px ${theme.palette.divider}`,
          display: 'grid',
          gridAutoRows: 'auto',
          gridTemplateColumns,
          gridTemplateRows: '35px',
        })}
      >
        {columns.map((column) => (
          <TableHeader key={column.key} title={column.title} sx={column.sx} />
        ))}

        {loads.map((load, index) => {
          const ticket = tickets.find((ticket) => ticket.loadId === load.id);
          const job = jobs.find((job) => job.id === load.jobId);

          return (
            <TableRow
              key={load.id}
              job={job}
              load={load}
              loadNumber={index + 1}
              onClick={onTableRowClick}
              order={order}
              ticket={ticket}
            />
          );
        })}
      </Box>
    </>
  );
}
